export default __webpack_public_path__ + "static/media/logo-myhealthcare.de3975ff.svg";